/**
* 员工管理-员工管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>员工管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.staffName" placeholder="员工名"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.staffWechatName" placeholder="微信名"></el-input>
      </el-form-item>
      <el-form-item v-if="mchEnum.length > 1">
        <el-select size="small" v-model="formInline.mchId" placeholder="请选择门店" @change="search">
          <el-option v-for="mch in mchEnum" :label="mch.mchName" :value="mch.mchId" :key="mch.mchId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="formInline.staffState" clearable placeholder="请选择员工状态">
          <el-option v-for="type in staffStateEnum" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column sortable prop="staffName" label="员工名" width="90">
      </el-table-column>
      <el-table-column sortable prop="staffWechatName" label="微信名" width="90">
      </el-table-column>
      <el-table-column sortable prop="staffPhone" label="手机号" width="110">
      </el-table-column>
      <el-table-column sortable prop="role.roleName" label="职位" width="90">
      </el-table-column>
      <el-table-column sortable prop="basicSalary" label="底薪" width="90">
      </el-table-column>
      <el-table-column sortable prop="performanceTemplate.templateName" label="绩效模板" width="120">
      </el-table-column>
      <el-table-column sortable prop="eyelashCommission" label="美睫提成" width="90">
        <template slot-scope="scope">
          <span>{{formatPercent(scope.row.eyelashCommission)}}</span>
        </template>
      </el-table-column>
      <el-table-column sortable prop="staffState" label="状态" width="90">
        <template slot-scope="scope">
          <span>{{staffStateFormat(scope.row.staffState)}}</span>
        </template>
      </el-table-column>
      <el-table-column sortable prop="joinReward" label="参与奖励" width="90">
        <template slot-scope="scope">
          <span>{{scope.row.joinReward === 0 ? '不参与' : '参与'}}</span>
        </template>
      </el-table-column>
      <el-table-column sortable prop="entryTime" label="入职时间" width="100">
        <template slot-scope="scope">
          <div>{{formatDate(scope.row.entryTime)}}</div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="entryTime" label="离职时间" width="100">
        <template slot-scope="scope">
          <div>{{formatDate(scope.row.resignationTime)}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="60%" @click="closeDialog">
      <el-form label-width="160px" :model="editForm" :rules="rules" ref="editForm">
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="10">
            <el-form-item label="姓名" prop="staffName">
              <el-input size="small" v-model="editForm.staffName" auto-complete="off" placeholder="请输入姓名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="微信号" prop="staffWechatName">
              <el-input size="small" v-model="editForm.staffWechatName" auto-complete="off" placeholder="请输入微信名"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="10">
            <el-form-item label="登录名" prop="loginName">
              <el-input size="small" v-model="editForm.loginName" auto-complete="off" placeholder="员工登录用的账号，如名字拼音"></el-input>
              <div style="color: #909399; font-size: 12px; line-height: 18px;">新员工初始密码统一为 12345678</div>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="登录密码" prop="dd">
              <el-input size="small" value="12345678" auto-complete="off" placeholder="" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="10">
            <el-form-item label="身份证号" prop="staffIdNo">
              <el-input size="small" v-model="editForm.staffIdNo" auto-complete="off" placeholder="请输入身份证号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="邮箱地址" prop="staffMail">
              <el-input size="small" v-model="editForm.staffMail" auto-complete="off" placeholder="请输入邮箱地址"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="10">
            <el-form-item label="工资类型" prop="incomeMethod">
              <el-radio v-model="editForm.incomeMethod" :label="1">绩效</el-radio>
              <el-radio v-model="editForm.incomeMethod" :label="2">分红</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="联系电话" prop="staffPhone">
              <el-input size="small" v-model="editForm.staffPhone" auto-complete="off" placeholder="请输入联系电话"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="20">
            <el-form-item label="户口所在地" prop="staffIdAddress">
              <el-input size="small" v-model="editForm.staffIdAddress" auto-complete="off" placeholder="请输入户口所在地"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="20">
            <el-form-item label="现居地" prop="staffCurrentAddress">
              <el-input size="small" v-model="editForm.staffCurrentAddress" auto-complete="off" placeholder="请输入现居地"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="10">
            <el-form-item label="底薪" prop="basicSalary">
              <el-input size="small" v-model="editForm.basicSalary" auto-complete="off" placeholder="请输入底薪"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="手工提成" prop="performanceTemplateId">
              <el-select size="small" v-model="editForm.performanceTemplateId" clearable placeholder="请选择手工提成">
                <el-option v-for="type in salaryTemplateEnum" :label="type.templateName" :value="type.templateId" :key="type.templateId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="10">
            <el-form-item label="状态" prop="staffState">
              <el-select size="small" v-model="editForm.staffState" clearable placeholder="请选择状态">
                <el-option v-for="type in staffStateEnum" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="岗位" prop="roleId">
              <el-select size="small" v-model="editForm.roleId" clearable placeholder="请选择岗位">
                <el-option v-for="type in roleEnum" :label="type.roleName" :value="type.roleId" :key="type.roleId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="10">
            <el-form-item label="是否参与奖励" prop="joinReward">
              <el-switch
                v-model="editForm.joinReward"
                :active-value="1"
                :inactive-value="0">
              </el-switch>
              <span style="margin-left: 8px; color: #909399; font-size: 12px;">关闭后不再纳入任何奖励模板的计算(周翻单/月指定/周办卡/月度排行等)</span>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="美睫提成" prop="eyelashCommission">
              <el-input-number size="small" v-model="eyelashPercent" :min="0" :max="100" :precision="1" :step="1" controls-position="right"></el-input-number>
              <span style="margin-left: 6px;">%</span>
              <div style="color: #909399; font-size: 12px; line-height: 18px;">会员、非会员美睫手工都按这个比例，默认 23%，10 月工资起生效</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="10">
            <el-form-item label="入职时间" prop="entryTime">
              <el-date-picker
                size="small"
                v-model="editForm.entryTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="请选择入职时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="离职时间" prop="resignationTime">
              <el-input size="small" v-model="editForm.resignationTime" auto-complete="off" placeholder="请选择离职时间" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  queryStaffPageList,
  deptDelete,
  getAllMchRoleList,
  getAllStaffTemplateList,
  saveOrUpdateStaff,
  getUserMchList
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '员工',
      roleEnum:[],
      salaryTemplateEnum:[],
      staffStateEnum:[
        { key: '在职', value: 1},
        { key: '离职', value: 0},
      ],
      mchEnum:[],
      editForm: {
        staffId: '',
        loginName:'',
        staffName: '',
        staffWechatName: '',
        staffAge:'',
        staffPhone:'',
        staffIdNo:'',
        incomeMethod:null,
        staffMail:'',
        staffCurrentAddress:'',
        staffIdAddress:'',
        basicSalary:0,
        performanceTemplateId:null,
        staffState:null,
        roleId:null,
        userId:null,
        entryTime:null,
        resignationTime:null,
        joinReward:1,
        eyelashCommission:0.23,
        token: localStorage.getItem('logintoken')
      },
      // rules表单验证
      rules: {
      },
      formInline: {
        current: 1,
        size: 10,
        staffName: '',
        staffWechatName: '',
        staffState:null,
        // 不传时后端按当前登录门店查；关联多店的账号靠上面的下拉切
        mchId:null,
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  computed: {
    // 库里存小数（0.23），表单上按百分比填（23）
    eyelashPercent: {
      get() {
        const v = this.editForm.eyelashCommission
        return v == null ? 23 : Math.round(Number(v) * 1000) / 10
      },
      set(val) {
        this.editForm.eyelashCommission = val == null ? 0.23 : Math.round(Number(val) * 10) / 1000
      }
    }
  },
  created() {
    this.getdata(this.formInline)
    // 初始化角色选择菜单
    this.initRoleEnum()
    // 初始化绩效模板选择菜单
    this.initSalaryTemplateEnum()
    // 初始化门店选择菜单
    this.initMchEnum()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    formatPercent(v) {
      return v == null ? '23%' : (Math.round(Number(v) * 1000) / 10) + '%'
    },
    // 获取公司列表
    getdata(parameter) {
      this.loading=true
      queryStaffPageList(parameter)
        .then(res => {
          this.loading = false
          if (res.code !== '200') {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            // 分页赋值
            this.listData = res.data.content
            // 分页赋值
            this.pageparm.total = res.data.total
          }
        }).catch(()=> {
        this.loading = false
        this.$message.error('员工数据加载失败，请稍后再试！')
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.current = parm.currentPage
      this.formInline.size = parm.pageSize
      this.pageparm.currentPage = parm.currentPage
      this.pageparm.pageSize = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      // 搜索条件变化后回到第一页，否则停在第 N 页会搜出空列表
      this.formInline.current = 1
      this.pageparm.currentPage = 1
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row !== undefined && row !== 'undefined') {
        this.title = '修改员工信息'
        this.editForm.staffId= row.staffId,
          this.editForm.loginName=row.user.loginName,
          this.editForm.staffName= row.staffName,
          this.editForm.staffWechatName= row.staffWechatName,
          this.editForm.staffAge=row.staffAge,
          this.editForm.staffPhone=row.staffPhone,
          this.editForm.staffIdNo=row.staffIdNo,
          this.editForm.staffMail=row.staffMail,
          this.editForm.incomeMethod=row.incomeMethod,
          this.editForm.staffCurrentAddress=row.staffCurrentAddress,
          this.editForm.staffIdAddress=row.staffIdAddress,
          this.editForm.basicSalary=row.basicSalary,
          this.editForm.performanceTemplateId=row.performanceTemplateId,
          this.editForm.staffState=row.staffState,
          this.editForm.roleId=row.roleId,
          this.editForm.userId=row.userId,
          this.editForm.entryTime=row.entryTime,
          this.editForm.resignationTime=row.resignationTime,
          this.editForm.joinReward=row.joinReward === 0 ? 0 : 1
          this.editForm.eyelashCommission=row.eyelashCommission == null ? 0.23 : Number(row.eyelashCommission)
      } else {
        this.title = '员工入职表'
        this.editForm.staffState = 1
        this.editForm.deptName = ''
        this.editForm.deptNo = ''
        this.editForm.incomeMethod=1
        this.editForm.joinReward=1
        this.editForm.eyelashCommission=0.23
      }
    },
    // 员工入职及修改
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          saveOrUpdateStaff(this.editForm).then(res => {
            this.editFormVisible = false
            this.loading = false
            if (res.code==='200') {
              this.getdata(this.formInline)
              this.$message({
                type: 'success',
                message: '员工保存成功！'
              })
            } else {
              this.$message({
                type: 'info',
                message: res.message
              })
            }
          }).catch(() => {
            this.editFormVisible = false
            this.loading = false
            this.$message.error('员工保存失败，请稍后再试！')
          })
        } else {
          return false
        }
      })
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deptDelete(row.deptId)
          .then(res => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '公司已删除!'
              })
              this.getdata(this.formInline)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          }).catch(() => {
          this.loading = false
          this.$message.error('公司删除失败，请稍后再试！')
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    },
    // 门店下拉：只有关联多家店的账号才会显示，默认选中当前登录门店（列表第一家）
    initMchEnum(){
      getUserMchList()
        .then(res => {
          if (res.code === '200') {
            this.mchEnum = res.data || []
            if (this.mchEnum.length > 1 && !this.formInline.mchId) {
              this.formInline.mchId = this.mchEnum[0].mchId
            }
          }
        })
        .catch(() => {})
    },
    initRoleEnum(){
      getAllMchRoleList()
        .then(res => {
          if (res.data.code==='200') {
            // 初始化角色列表
            this.roleEnum=res.data.data;
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
    },
    initSalaryTemplateEnum(){
      getAllStaffTemplateList()
        .then(res => {
          if (res.data.code==='200') {
            // 初始化角色列表
            this.salaryTemplateEnum=res.data.data;
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })

    },
    formatDate(timestamp){
      if(timestamp===null){
        return '';
      }
      const dateObj = new Date(timestamp);
      const year = dateObj.getFullYear();
      const month = ('0' + (dateObj.getMonth() + 1)).slice(-2);
      const day = ('0' + dateObj.getDate()).slice(-2);
      return `${year}-${month}-${day}`;
    },
    staffStateFormat(itemValue){
      for(let obj of this.staffStateEnum){
        if(obj.value===itemValue){
          return obj.key;
        }
      }
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
</style>




// WEBPACK FOOTER //
// src/views/staff/Staff.vue